// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";
// @ts-ignore
import { ImageElementData } from "./image_element_data";

export class UpdateImageElementDataStructReducer extends Reducer
{
	public static reducerName: string = "UpdateImageElementDataStruct";
	public static call(_elementId: number, _imageElementData: ImageElementData) {
		this.getReducer().call(_elementId, _imageElementData);
	}

	public call(_elementId: number, _imageElementData: ImageElementData) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _imageElementDataType = ImageElementData.getAlgebraicType();
		serializer.write(_imageElementDataType, _imageElementData);
		this.client.call("UpdateImageElementDataStruct", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let imageElementDataType = ImageElementData.getAlgebraicType();
		let imageElementDataValue = AlgebraicValue.deserialize(imageElementDataType, adapter.next())
		let imageElementData = ImageElementData.fromValue(imageElementDataValue);
		return [elementId, imageElementData];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _imageElementData: ImageElementData) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _imageElementData: ImageElementData) => void)
	{
		this.client.on("reducer:UpdateImageElementDataStruct", callback);
	}
}


export default UpdateImageElementDataStructReducer
